import { gql } from "@apollo/client"
export const ADD_STUDENT_NOTE_MUTATION = gql(`
    mutation AddStudentNote($studentId: UUID! $type: NoteTypeEnum!, $body: String!, $origin: NoteOriginType!) {
        addStudentNote(input: { studentId: $studentId, type: $type, body: $body, origin:$origin }) {
            __typename
            errors {
                __typename
                ... on UnknownError {
                    message
                }
                ... on ValidationError {
                    message
                    errors {
                        fieldName
                        messages
                    }
                }
            }
        }
    }`)
